var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 169,
    viewBox: "0 0 215 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.67016 47.9065C1.64319 41.8269 4.95513 35.2464 11.0676 33.2084L99.6083 3.68841C105.721 1.65048 112.319 4.92689 114.346 11.0065L151.048 121.087C153.075 127.167 149.763 133.747 143.65 135.785L55.1096 165.305C48.9971 167.343 42.3988 164.067 40.3718 157.987L3.67016 47.9065Z",
    fill: "url(#paint0_linear_2897_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7912 63.7318C26.7394 60.577 28.3643 57.1935 31.4205 56.1745L48.0219 50.6395C51.0781 49.6206 54.4084 51.352 55.4602 54.5068L61.1738 71.6437C62.2256 74.7986 60.6007 78.1821 57.5445 79.201L40.9431 84.736C37.8869 85.755 34.5566 84.0236 33.5048 80.8687L27.7912 63.7318Z",
    fill: "url(#paint1_linear_2897_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8444 52.8133C59.7762 49.6092 61.3577 46.1957 64.377 45.189L97.1781 34.2529C100.197 33.2463 103.511 35.0277 104.579 38.2318V38.2318C105.648 41.4359 104.066 44.8494 101.047 45.8561L68.2456 56.7922C65.2263 57.7988 61.9127 56.0174 60.8444 52.8133V52.8133Z",
    fill: "url(#paint2_linear_2897_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0202 100.415C38.9519 97.2107 40.5407 93.7949 43.5687 92.7853L109.362 70.8493C112.39 69.8397 115.711 71.6188 116.779 74.8229V74.8229C117.848 78.027 116.259 81.4429 113.231 82.4524L47.4373 104.388C44.4092 105.398 41.0885 103.619 40.0202 100.415V100.415Z",
    fill: "#C5D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5671 120.052C45.4988 116.847 47.0875 113.432 50.1156 112.422L115.909 90.486C118.937 89.4765 122.258 91.2555 123.326 94.4596V94.4596C124.394 97.6637 122.806 101.08 119.778 102.089L53.9842 124.025C50.9561 125.035 47.6354 123.256 46.5671 120.052V120.052Z",
    fill: "#C5D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4978 69.7742C65.4295 66.5701 67.041 63.1466 70.0973 62.1277L86.6986 56.5927C89.7549 55.5737 93.0984 57.3451 94.1667 60.5492V60.5492C95.235 63.7533 93.6234 67.1768 90.5672 68.1958L73.9658 73.7308C70.9096 74.7497 67.566 72.9783 66.4978 69.7742V69.7742Z",
    fill: "url(#paint3_linear_2897_3072)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9023 26.4827C36.9023 20.0741 42.1256 14.8789 48.5689 14.8789H141.901C148.344 14.8789 153.567 20.0741 153.567 26.4827V142.521C153.567 148.929 148.344 154.124 141.901 154.124H48.5689C42.1256 154.124 36.9023 148.929 36.9023 142.521V26.4827Z",
    fill: "url(#paint4_linear_2897_3072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7783 49.123C54.7783 45.7974 57.39 43.1016 60.6116 43.1016H78.1114C81.333 43.1016 83.9446 45.7974 83.9446 49.123V67.1873C83.9446 70.5128 81.333 73.2087 78.1114 73.2087H60.6116C57.39 73.2087 54.7783 70.5128 54.7783 67.1873V49.123Z",
    fill: "url(#paint5_linear_2897_3072)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5898 49.2171C89.5898 45.8396 92.1699 43.1016 95.3525 43.1016H129.929C133.111 43.1016 135.691 45.8396 135.691 49.2171V49.2171C135.691 52.5946 133.111 55.3326 129.929 55.3326H95.3525C92.1699 55.3326 89.5898 52.5946 89.5898 49.2171V49.2171Z",
    fill: "url(#paint6_linear_2897_3072)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7783 87.7952C54.7783 84.4177 57.3659 81.6797 60.5578 81.6797H129.912C133.104 81.6797 135.691 84.4177 135.691 87.7952V87.7952C135.691 91.1727 133.104 93.9107 129.912 93.9107H60.5578C57.3659 93.9107 54.7783 91.1727 54.7783 87.7952V87.7952Z",
    fill: "#C5D9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7783 108.494C54.7783 105.117 57.3659 102.379 60.5578 102.379H129.912C133.104 102.379 135.691 105.117 135.691 108.494V108.494C135.691 111.872 133.104 114.61 129.912 114.61H60.5578C57.3659 114.61 54.7783 111.872 54.7783 108.494V108.494Z",
    fill: "#C5D9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7783 128.253C54.7783 125.395 57.3935 123.078 60.6194 123.078H169.366C172.592 123.078 175.207 125.395 175.207 128.253C175.207 131.111 172.592 133.427 169.366 133.427H60.6194C57.3935 133.427 54.7783 131.111 54.7783 128.253Z",
    fill: "url(#paint7_linear_2897_3072)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5898 67.096C89.5898 63.7185 92.2015 60.9805 95.4231 60.9805H112.923C116.144 60.9805 118.756 63.7185 118.756 67.096V67.096C118.756 70.4735 116.144 73.2115 112.923 73.2115H95.4231C92.2015 73.2115 89.5898 70.4735 89.5898 67.096V67.096Z",
    fill: "url(#paint8_linear_2897_3072)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.624 36.7305L197.591 40.722L177.633 95.5545L166.667 91.563L186.624 36.7305Z",
    fill: "url(#paint9_linear_2897_3072)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.61 17.5379C194.712 14.5096 198.06 12.9482 201.089 14.0504C204.117 15.1526 205.678 18.5011 204.576 21.5294L197.591 40.7208L186.625 36.7293L193.61 17.5379Z",
    fill: "url(#paint10_linear_2897_3072)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.353 21.2768C195.904 19.7626 197.578 18.9819 199.092 19.533C200.606 20.0841 201.387 21.7584 200.836 23.2725L195.847 36.9807L190.363 34.9849L195.353 21.2768Z",
    fill: "url(#paint11_linear_2897_3072)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.67 91.5586L177.636 95.5501L167.208 116.612C166.472 118.101 164.733 118.797 163.172 118.229C161.612 117.661 160.727 116.01 161.12 114.396L166.67 91.5586Z",
    fill: "url(#paint12_linear_2897_3072)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.205 116.612C166.468 118.101 164.73 118.798 163.169 118.23C161.608 117.662 160.725 116.01 161.117 114.396L161.815 111.527L168.514 113.966L167.205 116.612Z",
    fill: "url(#paint13_linear_2897_3072)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M200.335 41.7227L205.818 43.7184L197.835 65.6514C196.733 68.6797 193.385 70.2411 190.356 69.1389L200.335 41.7227Z",
    fill: "url(#paint14_linear_2897_3072)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2897_3072",
    x1: 55.3379,
    y1: 18.4484,
    x2: 99.3799,
    y2: 150.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2897_3072",
    x1: 39.7212,
    y1: 53.407,
    x2: 49.2438,
    y2: 81.9685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2897_3072",
    x1: 80.7776,
    y1: 39.721,
    x2: 84.6461,
    y2: 51.3241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2897_3072",
    x1: 78.398,
    y1: 59.3602,
    x2: 82.2665,
    y2: 70.9633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2897_3072",
    x1: 95.2349,
    y1: 14.8789,
    x2: 95.2349,
    y2: 154.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2897_3072",
    x1: 69.3615,
    y1: 43.1016,
    x2: 69.3615,
    y2: 73.2087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2897_3072",
    x1: 112.641,
    y1: 43.1016,
    x2: 112.641,
    y2: 55.3326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2897_3072",
    x1: 114.993,
    y1: 123.078,
    x2: 114.993,
    y2: 133.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2897_3072",
    x1: 104.173,
    y1: 60.9805,
    x2: 104.173,
    y2: 73.2115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2897_3072",
    x1: 192.107,
    y1: 38.7262,
    x2: 172.15,
    y2: 93.5588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2897_3072",
    x1: 201.089,
    y1: 14.0504,
    x2: 192.108,
    y2: 38.7251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2897_3072",
    x1: 199.092,
    y1: 19.533,
    x2: 193.105,
    y2: 35.9828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2897_3072",
    x1: 172.153,
    y1: 93.5543,
    x2: 163.172,
    y2: 118.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2897_3072",
    x1: 165.165,
    y1: 112.746,
    x2: 163.169,
    y2: 118.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2897_3072",
    x1: 203.077,
    y1: 42.7205,
    x2: 193.098,
    y2: 70.1368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealInfo);
export default __webpack_public_path__ + "static/media/realInfo.b00f3e74881c12301ae360b281d8d2be.svg";
export { ForwardRef as ReactComponent };